import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Footer.css';

// 사이트 하단 공통 footer. 사업자 정보(상호/대표자/사업자등록번호/주소/전화)를
// 포함한다 — PG(나이스페이먼츠) 가맹심사 및 전자상거래법상 표시 의무 대응 (2026-09-02).
const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <footer className="home-footer" id="contact">
      <div className="container">
        <div className="footer-top">
          <div className="footer-brand">
            <Link to="/" className="logo-footer">freematch</Link>
            <p>{t('home.footerDesc1')}<br />{t('home.footerDesc2')}</p>
          </div>
          <div className="footer-links">
            <Link to="/terms">{t('home.terms')}</Link>
            <Link to="/privacy">{t('home.privacy')}</Link>
            <a href="mailto:kunkong.co@gmail.com">{t('home.contact')}</a>
          </div>
        </div>

        <div className="footer-business">
          <span>{t('home.bizName')}: KUNKONG</span>
          <span>{t('home.bizRep')}: 박기범</span>
          <span>{t('home.bizRegNo')}: 306-38-75095</span>
          <span>{t('home.bizAddress')}: 경기도 화성시 왕배산1길 3-4, 3층</span>
          <span>{t('home.bizPhone')}: 010-6284-2450</span>
        </div>

        <div className="footer-bottom">
          <p>© 2025 freematch. All rights reserved.</p>
          <p className="footer-contact">kunkong.co@gmail.com</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
